import _ from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
// @mui
import { Stack } from '@mui/system';
// sections
import Header from './Header';
// reducers
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import { intializeBeneficiary, getBeneficiaries } from 'state/reducers/beneficiary.reducers';
//components
import { Page } from 'theme/elements/Page';
//constants
import Details from './payDetails';
import { CenteredNarrowContent } from 'theme/elements/Content';
import { getOpenPendingRequestsPayments } from 'state/reducers/requests.reducers';
import { getPaymentById } from 'services/pay.services';
import MobileNavbar from 'sections/layout/MobileNavbar';
import { getHistory, togglePage } from 'state/reducers/ui.reducers';
import { pagesEnum } from 'constants/ui.constants';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getUrlBack } from 'theme/elements/Headers';
import Step4 from '../upsert/steps/step4';
import { Pay } from 'constants/pay.constants';

export default function PayRequestDetails(props: { allowActions?: boolean }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const t = useAppSelector(selectTranslations);
  const [payment, setPayment] = useState<Record<string, any> & Pay | undefined>();
  //get location
  const paths = location.pathname.split('/');
  const lastPath = paths[paths.length - 1];
  const beneficiaries = _.keyBy(useAppSelector(getBeneficiaries), 'id');
  const [beneficiary, setBeneficiary] = useState();
  const history = useAppSelector(getHistory);
  const urlback = getUrlBack(location.pathname, history[history.length - 1]);

  const getTotalAmount = (payment) => {
    let total = Number(payment.amount)
    if (payment?.fee) {
      total += Number(payment?.fee)
    }
    return _.isNumber(total) ? total.toFixed(2) : total
  }

  useEffect(() => {
    dispatch(getPaymentById(lastPath)).then(res => {
      if (res) {
        setPayment({
          ...res,
          paymentType: _.lowerCase(res.type),
          fee: res?.fee?.amount
        })
      }
    })
  }, [lastPath]);

  return (
    <>
      <MobileNavbar
        label={`${t('title.activity.type.paymentActivities')} ${payment?.reference}`}
        handleBack={() => {
          dispatch(togglePage(urlback));
        }}
        noCancel
      />
      {payment && (
        <Page>
          <Stack spacing={8}>
            <Header payment={{ ...payment, amount: getTotalAmount(payment) }} beneficiary={payment?.beneficiary} allowActions={props.allowActions} />
            <CenteredNarrowContent>
              <Step4 _payment={payment} readOnly={true} />
            </CenteredNarrowContent>
          </Stack>
        </Page>
      )}
    </>
  );
}
